export enum Scanners {
	GLOVE_SCANNER = 'glove_scanner',
	ZEBRA_SCANNER = 'zebra'
}
